// This function is a wrapper around normalizer. This ensures the
// high level entity objects / relationship are defined as empty arrays
// instead of undefined when the hit the reducer

import normalize from 'json-api-normalizer';

export default function normalizer(schema, data) {
  return { ...schema, ...normalize(data) };
}
